module.exports = __webpack_public_path__ + "img/b873f12053be934dde3569f51b1ab0f9.jpg";